import { customDispatch } from "@affinity/Store/ServiceBase";
import { AffinityDelivery, AffinityProduct, ProductModelX } from "@affinity/Store/StoreTypes";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { getBillTo } from "@insite/client-framework/Services/CustomersService";
import { BillToModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";

// External parameters
export interface PlaceOrderSetPriceAndDeliveryOpttionParameters {
    delivery: AffinityDelivery,
    billToId: string,
}
// Internal parameters
interface Props {
    delivery: AffinityDelivery,
    billTo: BillToModel,
    phone: string | undefined,
}

type HandlerType = Handler<PlaceOrderSetPriceAndDeliveryOpttionParameters, Props>;

const GetPhone: HandlerType = async props => {
    if (props.parameter.billToId) {
        props.billTo = await getBillTo({ billToId: props.parameter.billToId })
    }

    props.phone = props.billTo.phone;
}

const UpdateState: HandlerType = props => {
    (props.dispatch as customDispatch)({
        type: "Affinity/PriceAndDeliveryOption/Set",
        delivery: props.parameter.delivery,
        phone: props.phone,
    });
}

const Tracking: HandlerType = props => {
    //
}

const chain = [
    GetPhone,
    UpdateState,
    Tracking,
];

export const PlaceOrderSetPriceAndDeliveryOption = createHandlerChainRunner(chain, "PlaceOrderSetPriceAndDeliveryOption");
export default PlaceOrderSetPriceAndDeliveryOption;